import { Link, styled } from '@mui/material'
import AppBar from '@mui/material/AppBar'
import Toolbar from '@mui/material/Toolbar'
import { useTheme } from '@mui/material/styles'
import useMediaQuery from '@mui/material/useMediaQuery'
import UnauthenticatedMenu from '../../../components/appBar/UnauthenticatedMenu'
import Logo from '../../../svg/Logo'

const StyledLink = styled(Link)(({ theme }) => ({
  width: '100px',
  [theme.breakpoints.up('sm')]: {
    width: '120px'
  },
  [theme.breakpoints.up('md')]: {
    width: '180px'
  },
  [theme.breakpoints.up('xl')]: {
    width: '300px'
  }
}))

export default function Header() {
  const theme = useTheme()
  const isTablet = useMediaQuery(theme.breakpoints.down('lg'))

  return (
    <AppBar
      position="relative"
      elevation={0}
      color="inherit"
      sx={{
        justifyContent: 'center',
        alignItems: 'center',
        border: '1px solid #E4E7EC',
        minHeight: 0
      }}
    >
      <Toolbar
        disableGutters={isTablet}
        sx={{
          flexWrap: 'wrap',
          justifyContent: 'space-between',
          alignItems: 'stretch',
          maxWidth: theme.breakpoints.values.xl,
          width: '100%',
          minHeight: '0 !important',
          padding: { xs: '10px 12px', sm: '14px 18px', xl: '25px 40px' }
        }}
      >
        <StyledLink href="/" aria-label="Photobucket Homepage" id="appbar-logo" data-test="appbar-logo" title="home page">
          <Logo />
        </StyledLink>
        <UnauthenticatedMenu />
      </Toolbar>
    </AppBar>
  )
}
